import React from 'react'
import { SecondaryPageBannerFragment } from '@gql'
import { SecondaryPageBanner } from '../../../fragments/secondaryPageBanner'
import { Breadcrumb, Breadcrumbs } from '../../../components/breadcrumbs/Breadcrumbs'

export type SecondaryPageBannerProps = {
  layout: 'vertical' | 'horizontal'
  secondaryPageBanner?: SecondaryPageBannerFragment[]
}
export const FAQBanner: React.VFC<SecondaryPageBannerProps> = ({ secondaryPageBanner }) => {
  if (!secondaryPageBanner?.[0]) {
    return null
  }

  const { title, subTitle, primaryButton, subBanner } = secondaryPageBanner[0]

  type QuickLinkBlock = Extract<
    NonNullable<SecondaryPageBannerFragment['subBanner']>[number],
    { __typename: 'subBanner_quickLinks_BlockType' }
  >

  const filteredSubBanner = (subBanner?.filter(
    (item): item is QuickLinkBlock =>
      item?.__typename === 'subBanner_quickLinks_BlockType'
  ) ?? []) as SecondaryPageBannerFragment['subBanner']

  return (
    <SecondaryPageBanner
      title={title}
      subTitle={subTitle}
      primaryButton={primaryButton}
      secondaryButton={undefined}
      subBanner={subBanner}
      //@ts-ignore
      image={undefined}
      breadcrumbs={(
        <Breadcrumbs>
          <Breadcrumb href={'/'} home text={'Home'} />
          <Breadcrumb href={'/help-and-support'} text={'Help and Support'} />
          <Breadcrumb href={'/help-and-support/faqs'} text={'FAQs'} />
        </Breadcrumbs>
      )}
    />
  )
}